/**
 * @generated SignedSource<<43e72e7cb56446fc8aeb873bf839c667>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportContainer_report$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ReportViewContainer_report" | "ReportContent_report" | "ReportResolution_report" | "ReportResolutionTable_report">;
  readonly " $fragmentType": "ReportContainer_report";
};
export type ReportContainer_report$key = {
  readonly " $data"?: ReportContainer_report$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReportContainer_report">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportContainer_report",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReportViewContainer_report"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReportContent_report"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReportResolution_report"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReportResolutionTable_report"
    }
  ],
  "type": "Report",
  "abstractKey": null
};

(node as any).hash = "9e5fae7b788aff9e609472877c6cadaf";

export default node;
